// extracted by mini-css-extract-plugin
module.exports = {"form-wrapper":"styles_form-wrapper__2wZWV","form":"styles_form__1qYuc","inputs":"styles_inputs__KxIGw","buttons":"styles_buttons__2oQO7"};